import React, { FC, useCallback, useEffect, useState, useRef } from 'react';
import { t } from '../../../../utils/helpers';
import { container } from 'tsyringe';
import MainButton from '@ui-kit/components/mainButton';
import { IAuthService } from '@base/features/auth/model/interfaces';
import firebase from 'firebase';
import { ApplicationVerifier, ConfirmationResult } from '../../../../services/firebase/firebase';
import Modal from '@ui-kit/components/modal';
import PhoneInput from 'react-phone-input-2';
import { Loader } from '@ui-kit/components/loader';
import { useFormContext, useController } from 'react-hook-form';
import { IModalProvider } from '@base/features/modal/model/interfaces';

type PropsType = {
  mode?: 'request' | 'verification';
};

export const PhoneVerification: FC<PropsType> = ({ mode }) => {
  const { control, trigger, setValue, getValues, register } = useFormContext();
  const { field: phoneInput, fieldState } = useController({
    name: 'phoneValue',
    control,
    rules: {
      required: true,
      validate: (v) => regExpPhone.test(v),
    },
  });
  const [isVisibleError, setVisibleError] = useState<boolean>(false);
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const authService: IAuthService = container.resolve('authService');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const regExpPhone = /(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]‌​)\s*)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)([2-9]1[02-9]‌​|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})\s*(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+)\s*)?$/i;
  const {
    phoneVerification: { token, regCode },
  } = getValues();
  const [placeholderSendBtb, setPlaceholderSendBtb] = useState('send_verification_code');
  const [firstCode, setFirstCode] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [captchaVerifier, setCaptchaVerifier] = useState<ApplicationVerifier>();
  const captchaRef = useRef(null);

  useEffect(() => {
    if (captchaRef.current) {
      const recaptcha = new firebase.auth.RecaptchaVerifier(captchaRef.current, {
        size: 'invisible',
        'expired-callback': function () {
          modalProvider.show({
            buttons: [{ title: 'OK', onClick: () => modalProvider.hide() }],
            title: 'Error',
            body: 'Error resolving capcha. Please try again.',
          });
        },
      });
      setCaptchaVerifier(recaptcha);
      return () => {
        setLoading(false);
      };
    }
  }, [captchaRef.current]);

  function requestSmsCode(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    setLoading(true);
    captchaVerifier &&
      authService
        .requestSmsCode(`+${phoneInput.value}`, captchaVerifier)
        .then((confirmationResult: ConfirmationResult) => {
          //console.log('confirmationResult -- тут по капче все', confirmationResult);
          setPlaceholderSendBtb('resend');
          //ToDo в этот момент можно сделать счетчик для активации кнопки через 30 или 60сек
          modalProvider.show({
            title: 'success',
            body: `code sent to your phone ${phoneInput.value}`,
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
          setValue('emailValue', '');
          setFirstCode(true);
          setValue('phoneVerification.token', confirmationResult.verificationId);
        })
        .catch((e) => {
          setPlaceholderSendBtb('resend');
          modalProvider.show({
            title: 'Error',
            body: e.message,
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
        })
        .finally(() => {
          setLoading(false);
        });
  }

  const codeVerify = useCallback(
    (code: string) => {
      if (code.length !== 6) return;
      //ВКЛЮЧИТЬ ПРЕЛОАДЕР
      //вместо confirmationResult?.confirm(code) можно так:
      setLoading(true);
      authService
        .signInWithCredential(token, code)
        .then((res) => {
          setValue('phoneVerification', { token: res.user?.uid, regCode: '' });
          //теперь сохраняем другой токен для отправки в setPhone и сбрасываем поле код
          modalProvider.show({
            title: 'success',
            body: 'You code valid',
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
          setValue('phoneValid', true);
        })
        .catch((e) => {
          modalProvider.show({
            title: 'Error',
            body: e.message,
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [authService, setValue, token]
  );

  useEffect(() => {
    codeVerify(regCode);
  }, [regCode, codeVerify]);

  useEffect(() => {
    trigger('phoneValue');
  }, []);

  return (
    <div className="auth-form-item verification-phone">
      {isLoading && <Loader height={100} width={100} className="loader-container--black" />}
      <PhoneInput
        country={'us'}
        {...phoneInput}
        onFocus={() => {
          setValue('emailValue', '');
          setVisibleError(true);
        }}
        //placeholder='+1 234 567 89 10'
        containerClass="container-class"
        isValid={!fieldState.invalid || !isVisibleError}
      />

      <div className="verification-phone__confirm">
        {/*Hide when verify phone success*/}
        {!fieldState.invalid && firstCode && (
          <div className="verification-phone__confirm-input">
            <input
              className={
                !fieldState.invalid
                  ? 'auth-form-item__text auth-form-item__text--valid auth-form-item__email'
                  : 'auth-form-item__text auth-form-item__email'
              }
              placeholder={t('code')}
              id="regCode"
              type="text"
              maxLength={6}
              onChange={(e) => {
                setValue('phoneVerification.regCode', e.target.value);
              }}
            />
          </div>
        )}

        {/*Hide when verify phone success*/}
        {!fieldState.invalid && mode === 'verification' && (
          <MainButton
            className="verification-phone__confirm-send"
            id="btn-ver-code"
            onClick={requestSmsCode}
            ref={captchaRef}
          >
            {t(`${placeholderSendBtb}`)}
          </MainButton>
        )}
      </div>
    </div>
  );
};
